import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';

import ActionMixin from 'components/lib/action_mixin';
import AddCustomerButton from 'components/customer/add_customer_button';
import AppFeaturesMixin from 'components/lib/app_features_mixin';
import AgentInbox from './agent_inbox';
import InboxMenu from './agent_inbox/inbox_menu';
import PageLayout from './page_layout';
import ProvidersMixin from './lib/providers_mixin';
import SharedBindings from './lib/shared_bindings_mixin';

const AgentHome = createReactClass({
  mixins: [ActionMixin, AppFeaturesMixin, Morearty.Mixin, ProvidersMixin, SharedBindings],

  /* lifecycle */

  UNSAFE_componentWillMount() {
    this.observeBinding(this.getSharedBinding('currentLocation'));
  },

  /* rendering */

  render() {
    return (
      <PageLayout id="agent-home" className="agentHome-pageLayout">
        <div className="agent-home-body">
          {this.renderSideNav()}
          {this.renderInbox()}
        </div>
      </PageLayout>
    );
  },

  renderSideNav() {
    if (!this.isFeatureEnabled('groupInboxes')) {
      return null;
    }

    let teamInboxCounts = this.getDefaultBinding().get('teamInboxCounts');
    let personalInboxCounts = this.getDefaultBinding().get('personalInboxCounts');

    return (
      <div className="agentHome-sidenav-col">
        <InboxMenu
          personalInboxCount={personalInboxCounts ? personalInboxCounts.get('openCount') : 0}
          inboxState={this.getProvider('currentLocation').get()}
          teamInboxCounts={teamInboxCounts}
        />
      </div>
    );
  },

  renderInbox() {
    if (this.isFeatureEnabled('groupInboxes')) {
      return <div className="agentHome-inbox main-column">{this.renderAgentInbox()}</div>;
    }

    return <div className="agentHome-inbox-centered main-column">{this.renderAgentInbox()}</div>;
  },

  renderAgentInbox(binding) {
    return (
      <div className="agentHome-inbox-container">
        <AgentInbox />
        <AddCustomerButton />
      </div>
    );
  },
});

export default AgentHome;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/agent_home.jsx